import { mapActions, mapGetters, mapState } from 'vuex';
import ChromeDashboard from '@/components/chrome/Dashboard.vue';
import ListBox from '@/components/list/ListBox.vue';
import { messages, methods } from '../../common';

export default (storeName: string) => ({
  data: () => ({
    LINESHEET_LIMIT: messages.LINESHEET_LIMIT,
    fetched: false,
  }),
  computed: {
    ...mapGetters(storeName, [
      'linesheetLimitReached',
    ]),
    ...mapState(storeName, [
      'isLoading',
      'list',
      'page',
      'USER_LINESHEET_LIMIT',
    ]),
  },
  methods: {
    ...mapActions(storeName, ['load']),
    ...methods,
    fetchData() {
      return this.load();
    },
  },
  components: {
    ChromeDashboard,
    ListBox,
  },
} as IView);
